import { useMemo } from 'react'
import {
  LibraryFilterQueryFormData,
  useLibraryFilters
} from '../../api/react-query'
import { AggregationFilter } from '../filters/types'

interface Props {
  organizationID: string
  formData?: LibraryFilterQueryFormData
}

export const useFilters = ({ organizationID, formData }: Props) => {
  const assessFilters = useLibraryFilters({
    organizationID,
    enabled: true,
    formData
  })

  const isLoadingFilters = assessFilters.some((result) => result.isLoading)

  const libraryFiltersAssess = useMemo((): AggregationFilter[] => {
    if (assessFilters) {
      return (
        assessFilters.reduce((acc: AggregationFilter[], filter) => {
          if (filter.isLoading || filter.isError || !filter.data) {
            return acc
          }

          const aggregationFilter: AggregationFilter = {
            key: filter.data.filterType,
            label: filter.data.filterType,
            children: filter.data.filters?.map((childFilter) => {
              return {
                key: `${filter.data.filterType}.${childFilter.keycode}`,
                label: childFilter.label,
                parentKey: filter.data.filterType,
                children: [],
                count: childFilter.count,
                value: childFilter.keycode
              }
            })
          }

          acc?.push(aggregationFilter)

          return acc
        }, []) || []
      )
    }

    return []
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingFilters, assessFilters])

  return {
    isLoadingFilters,
    libraryFilters: libraryFiltersAssess,
    results: assessFilters
  }
}
